import { ContactFormFormField } from './lets-connect.types'

export const defaultContactFormValues = {
  [ContactFormFormField.Name]: '',
  [ContactFormFormField.Email]: '',
  [ContactFormFormField.Website]: '',
  [ContactFormFormField.Budget]: '',
  [ContactFormFormField.Message]: '',
  [ContactFormFormField.Urgent]: true
}